import React from 'react'
import { TextInput, ImageInput, NumberInput, required, useTranslate } from 'react-admin'
import { Grid } from '@material-ui/core'
import { maxLength } from 'react-admin'

import PreviewImage from 'components/previewImage'
import formatImageInput from 'utils/formatImageInput'

const Form = () => {
	const t = useTranslate()

	return (
		<Grid container spacing={4}>
			<Grid item xs={12} md={6}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<TextInput
							source="name"
							helperText="Name which is displayed in the website."
							fullWidth
							validate={required()}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<NumberInput
							source="order"
							min={0}
							max={1000}
							fullWidth
							helperText={t('orderHelperText')}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextInput source="shortDescription" helperText="Few words about the facility." validate={maxLength(20)} multiline fullWidth />
					</Grid>
					<Grid item xs={12}>
						<TextInput source="description" helperText="Full description of the facility." multiline fullWidth fullHeight />
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12} md={6}>
				<ImageInput source="imageName" format={formatImageInput()} validate={required()} accept="image/*">
					<PreviewImage source="imageName" />
				</ImageInput>
			</Grid>
		</Grid>
	)
}

export default Form
